import { get, post, postJson,putOne } from '../axios3'

const BASE_PATH = '/birthActivity';

// 生日有礼详情
export const getActivity = id => get(`${BASE_PATH}/`+id);
// 生日有礼保存
export const saveOrUpdate = p => postJson(`${BASE_PATH}/saveOrUpdate`,p);